module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./~/@aksharma25/react-schedulers-theralytics/lib/img/doctor.png
// module id = 1486
// module chunks = 0